import {GenericResourceInfo, GenericSelfInfo} from '@catcore/types/base';
import {Restangular} from 'ngx-restangular';
import 'rxjs/add/operator/delay';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Subject} from 'rxjs/Subject';
import {HttpResponse} from "@angular/common/http";
import {FileBlobResponse} from "@catcore/utils";
import {Observable} from "rxjs";

export abstract class RestHttpService<T> {

  private currentSource = new BehaviorSubject(null);
  private current: any = null;
  private inProcess = false;

  private current$ = this.currentSource.asObservable();

  constructor(private endpoint: string, private restService: Restangular) {
  }

  protected queryAll() {
    return this.restService.all(this.endpoint);
  }

  protected getServiceForOne(id: string) {
    return this
      .restService
      .one(this.endpoint, id);
  }

  loadAsCurrent(id: string) {
    if (!this.inProcess) {
      this.inProcess = true;
      this
        .getOne(id)
        .subscribe((entity: any) => {
          this.inProcess = false;
          this.setCurrent(entity);
        });
    }
  }

  setCurrent(entity: any) {
    this.current = entity;
    this.currentSource.next(this.current);
  }

  refreshCurrent() {
    if (this.current) {
      this.loadAsCurrent(this.current.id);
    }
  }

  resetCurrent() {
    this.setCurrent(null);
  }

  getCurrent() {
    return this.current$;
  }

  getAll(params: object = {}): Subject<T[]> {
    return this.restService
      .all(this.endpoint)
      .customGET('', params)
      .map((list) => {
        if (list.totalItems > 0) {
          return list._embedded.item;
        } else {
          return [];
        }
      })
      ;
  }

  getAllSubresources(id, subresourcePath, params = {}): Observable<any> {
    return this.getRawSubresource(id, subresourcePath, params)
      .map((list) => {
        if (list.totalItems > 0) {
          return list._embedded.item;
        } else {
          return [];
        }
      });
  }

  postSubresource(id, subresourcePath, params = {}): Observable<any> {
    return this.restService.one(this.endpoint, id).all(subresourcePath).customPOST(params);
  }

  getRawSubresource(id, subresourcePath, params = {}): Subject<any> {
    return this.restService.one(this.endpoint, id).all(subresourcePath).customGET('', params);
  }

  getOne(id: string): Subject<T> {
    return this.restService
      .all(this.endpoint)
      .get(id);
  }

  update(data) {
    return this.restService.one(this.endpoint, data.id).customPUT(data);
  }

  add(data) {
    return this.restService.all(this.endpoint).customPOST(data);
  }

  /**
   * Remove
   * @param {GenericResourceInfo} item
   */
  delete(item: GenericResourceInfo) {
    const ref = this.clearEndpoint(item._links.self.href);
    return this.restService.one(ref).remove();
  }
  /**
   * Clone
   * @param {GenericResourceInfo} item
   */
  clone(item: GenericResourceInfo) {
    const ref = this.clearEndpoint(item._links.self.href) + '/clone';
    return this.restService.one(ref).get();
  }
  /**
   * cleaning up the endpoint, because our api provides us with there subdirectory "api", which is already defined as base entrypoint
   * for Restangular.
   *
   * @param {string} endpoint
   * @returns {string}
   */
  private clearEndpoint(endpoint: string): string {
    return endpoint.replace(/^(\/api)/, '');
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/services/rest-http.service.ts